import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { formatDate } from '@angular/common';
import { from } from 'rxjs';
import { concatMap, delay, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-bookstoresendmessage1',
  templateUrl: './bookstoresendmessage1.component.html',
  styleUrls: ['./bookstoresendmessage1.component.scss']
})
export class Bookstoresendmessage1Component implements OnInit {

  books: any[] = [];
  booksByOrder: any[] = [];
  doneIds: number[] = [];
  isLoading = true;
  sendingWhatsApp: { [orderNo: string]: boolean } = {};
whatsAppSent: { [orderNo: string]: boolean } = {}; 
sendingAllWhatsApp = false;

  constructor(
    private fb: FormBuilder,
    private service: DigisubservicesService,
    private dialogRef: MatDialogRef<Bookstoresendmessage1Component>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {

    this.books = this.data?.receiptdata || [];

    // ✔ LOAD REMOVED IDS FROM SERVER (GLOBAL)
    this.service.getRemovedBookIds().subscribe({
      next: (removedIds: number[]) => {

        const removedSet = new Set(
          (removedIds || []).map(id => String(id))
        );

        this.buildOrderList(removedSet);
        this.isLoading = false;
      },
      error: () => {
        this.buildOrderList(new Set());
        this.isLoading = false;
      }
    });
  }

  // ================= BUILD ORDER LIST =================
  private buildOrderList(removedSet: Set<string>): void {

    const activeBooks = this.books.filter(
      b => !removedSet.has(String(b.id))
    );

    const map = new Map<string, any>();

    activeBooks.forEach(b => {

      b.address1 = [
        b.address,
        b.taluka,
        b.district,
        b.state,
        b.country,
        b.pincode ? `- ${b.pincode}` : null,
      ]
        .filter(p => p && String(p).trim() !== '')
        .join(', ');

      if (!map.has(b.order_no)) {
        map.set(b.order_no, {
          order_no: b.order_no,
          books: [],
          booksData: []
        });
      }

      map.get(b.order_no).books.push(b);
    });

    this.booksByOrder = Array.from(map.values());

    this.booksByOrder.forEach(order => {
      const firstId = order.books?.[0]?.id;

      if (firstId) {
        this.service.getBooks(firstId).subscribe((res: any[]) => {
          order.booksData = res?.length ? res : order.books;
        });
      } else {
        order.booksData = order.books;
      }
    });
  }



  // ================= MARK DONE =================
  // markDone(index: number): void {

  //   const order = this.booksByOrder[index];
  //   const ids = order.books.map((b: any) => Number(b.id));

  //   this.service.saveRemovedBookIds(ids).subscribe({
  //     next: () => {

  //       this.doneIds.push(...ids);

  //       this.booksByOrder.splice(index, 1);
  //       this.booksByOrder = [...this.booksByOrder];

  //     },
  //     error: () => {
  //       alert('Server error. Entry not removed.');
  //     }
  //   });
  // }

  // ================= MARK ALL DONE =================
  markAllDone(): void {

    if (!confirm('सर्व ऑर्डर पूर्ण झाल्या आहेत का?')) return;

    const ids: number[] = [];

    this.booksByOrder.forEach(order => {
      order.books.forEach((b: any) => {
        ids.push(Number(b.id));
      });
    });

    this.service.saveRemovedBookIds(ids).subscribe({
      next: () => {

        this.doneIds.push(...ids);
        this.booksByOrder = [];

      },
      error: () => {
        alert('Server error. Entries not removed.');
      }
    });
  }

  // ================= PRINT =================
  print(): void {

    if (!this.booksByOrder.length) {
      alert('No receipts available to print');
      return;
    }

    const printWindow = window.open('', '_blank', 'width=900,height=1200');

    if (!printWindow) {
      alert('Please allow popups to print');
      return;
    }

    const fmt = (date: any) => {
      try {
        return date ? formatDate(date, 'dd-MM-yyyy', 'en-IN') : '';
      } catch {
        return date || '';
      }
    };

    const pages: any[][] = [];

    for (let i = 0; i < this.booksByOrder.length; i += 3) {
      pages.push(this.booksByOrder.slice(i, i + 3));
    }

    const html = `
<!DOCTYPE html>
<html lang="mr">
<head>
<meta charset="UTF-8">
<style>
@page { size: A4; margin: 10mm; }
body { font-family: Arial; font-size: 11pt; margin: 0; }
.page { page-break-after: always; }
.receipt { border: 2px solid #000; padding: 8px; margin-bottom: 10px; }
.row { display: flex; }
.col { width: 50%; padding: 8px; }
.left { border-right: 2px dotted #000; }
.book-row { display: flex; margin-top: 3px; }
.b-name { flex: 1; }
.b-copy { width: 60px; text-align: right; }
.courier-row { display: flex; justify-content: space-between; margin-top: 10px; }
</style>
</head>
<body>

${pages.map(page => `
<div class="page">

${page.map(order => {

  const courierBlock = (order.couriername || order.courierdate) ? `
    <div class="courier-row">
      <div><b>कुरियर :</b> ${order.couriername || ''}</div>
      <div><b>दिनांक :</b> ${order.courierdate || ''}</div>
    </div>` : '';

  return `
<div class="receipt">
  <div class="row">

    <div class="col left">
      <div><b>बुक सेलर :</b> ${order.books?.[0]?.custname || ''}</div>
      <div><b>प्रतिनिधी :</b> ${order.books?.[0]?.rep || ''}</div>

      <div style="display:flex;justify-content:space-between;">
        <div><b>ऑर्डर नं :</b> ${order.order_no || ''}</div>
        <div><b>दिनांक :</b> ${fmt(order.books?.[0]?.bookingdate)}</div>
      </div>

      <div style="display:flex;justify-content:space-between;">
        <div><b>बिल नं :</b> ${order.books?.[0]?.invoice_no || ''}</div>
        <div><b>बिल दिनांक :</b> ${fmt(order.books?.[0]?.invoice_date)}</div>
      </div>

      <div style="display:flex;justify-content:space-between;">
        <div><b>पावती नं :</b> ${order.books?.[0]?.rcptno || ''}</div>
        <div><b>पावती दिनांक :</b> ${fmt(order.books?.[0]?.rcptdate)}</div>
      </div>

      <div style="display:flex; font-weight:bold; margin-top:10px;">
        <div style="width:70%;">पुस्तक</div>
        <div style="width:30%;">प्रती</div>
      </div>

      ${(order.booksData || order.books).map((b: any, idx: number) => `
        <div class="book-row">
          <div class="b-name">${idx + 1}) ${b.bookname || ''}</div>
          <div class="b-copy">${b.bookcopies || ''}</div>
        </div>
      `).join('')}

      ${courierBlock}
    </div>

    <div class="col">
      <div style="text-align:right; font-weight:bold;">
        ${order.books?.[0]?.deliverymode || 'By Hand'}
      </div>

      <div><b>प्रति,</b></div>
      <div><b>बुक सेलर :</b> ${order.books?.[0]?.custname || ''}</div>
      <div><b>पत्ता :</b> ${order.books?.[0]?.address1 || ''}</div>
      <div><b>मोबाईल :</b> ${order.books?.[0]?.mobile_no || ''}</div>

      <div style="display:flex; margin-top:20px;">
        <div style="width:40%;">
          <img src="../../../assets/img/brand/book.png" style="width:80%;" />
        </div>
        <div style="width:60%; font-size:10pt;">
          <b>प्रेषक,</b><br>
          हिंदुस्थान प्रकाशन संस्था - पुस्तक विभाग,<br>
           116-119,पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग,<br>
          वडाला मुंबई - 400031<br>
          दूरध्वनी: ९९६७५७०५३१
        </div>
      </div>
    </div>

  </div>
</div>
`;
}).join('')}

</div>
`).join('')}

</body>
</html>`;

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 500);
    };
  }

  // ================= CLOSE =================
  closeDialog(): void {
    if (this.doneIds.length > 0) {
      this.dialogRef.close({
        action: 'all_done',
        deliveredIds: this.doneIds
      });
    } else {
      this.dialogRef.close();
    }
  }


  // sendWhatsApp(order: any): void {

  //   const first = order.books?.[0];
  //   const mobile = first?.mobile_no;

  //   if (!mobile || String(mobile).trim() === '' || String(mobile) === '0') {
  //     alert('या ऑर्डरसाठी मोबाईल नंबर उपलब्ध नाही.');
  //     return;
  //   }

  //   const bookNames = (order.booksData?.length ? order.booksData : order.books)
  //     .map((b: any) => b.bookname)
  //     .filter((n: any) => !!n)
  //     .join(', ');

  //   const fmt = (date: any) => {
  //     try {
  //       return date ? formatDate(date, 'dd-MM-yyyy', 'en-IN') : '';
  //     } catch {
  //       return date || '';
  //     }
  //   };

  //   // ✔ Maps 1:1 to {{1}} - {{5}} in your AiSensy template
  //   const templateParams = [
  //     first?.custname || '',                          // {{1}} बुक सेलर
  //     first?.rep || '',                                // {{2}} प्रतिनिधी
  //     `ऑर्डर क्र : ${order.order_no || ''}`,            // {{3}}
  //     `दिनांक : ${fmt(first?.bookingdate)}`,            // {{4}}
  //     bookNames                                         // {{5}} पुस्तकांची नावे
  //   ];

  //   this.sendingWhatsApp[order.order_no] = true;

  //   this.service.sendWhatsAppReceipt({
  //     mobile: String(mobile),
  //     campaignName: 'courier', // <-- replace with your actual AiSensy campaign name
  //     templateParams
  //   }).subscribe({
  //     next: (res: any) => {
  //       this.sendingWhatsApp[order.order_no] = false;
  //       this.whatsAppSent[order.order_no] = true;
  //     },
  //     error: (err) => {
  //       this.sendingWhatsApp[order.order_no] = false;
  //       console.error('WhatsApp send failed:', err);
  //       alert('WhatsApp मेसेज पाठवताना त्रुटी आली.');
  //     }
  //   });
  // }

  // ADD THIS


//   sendWhatsApp(order: any): void {

//   if (!order) return;

//   const first = order.books?.[0];
//   const mobile = first?.mobile_no;

//   if (!mobile || String(mobile).trim() === '' || String(mobile) === '0') {
//     alert('या ऑर्डरसाठी मोबाईल नंबर उपलब्ध नाही.');
//     return;
//   }

//   const fmt = (date: any) => {
//     try {
//       return date ? formatDate(date, 'dd-MM-yyyy', 'en-IN') : '';
//     } catch {
//       return date || '';
//     }
//   };

//   const booksList = order.booksData?.length ? order.booksData : order.books;

//   // ✔ {{5}} - {{6}} → "bookname - prati" joined for multiple books
//   const bookNamesStr = booksList
//   .map((b: any) => b.bookname || '')
//   .join(', ');

// const bookNameCopiesStr = booksList
//   .map((b: any) => `${b.bookname || ''} - ${b.bookcopies || 0} `)
//   .join(', ');

// const templateParams = [
//   first?.custname || '',          // {{1}} नाव
//   first?.district || '',          // {{2}} जिल्हा
//   order.order_no || '',           // {{3}} ऑर्डर क्र
//   fmt(first?.bookingdate),        // {{4}} दिनांक
//   bookNamesStr,                   // {{5}} पुस्तक नाव
//   bookNameCopiesStr                   // {{6}} प्रती
// ];

//   this.sendingWhatsApp[order.order_no] = true;

//   this.service.sendWhatsAppReceipt({
//     mobile: String(mobile),
//     campaignName: 'courier_j4aut', // your actual campaign name
//     templateParams
//   }).subscribe({
//     next: (res: any) => {
//       this.sendingWhatsApp[order.order_no] = false;
//       this.whatsAppSent[order.order_no] = true;
//     },
//     error: (err) => {
//       this.sendingWhatsApp[order.order_no] = false;
//       console.error('WhatsApp send failed:', err);
//       alert('WhatsApp मेसेज पाठवताना त्रुटी आली.');
//     }
//   });
// }


// sendWhatsApp(order: any): void {

//   if (!order) return;

//   const first = order.books?.[0];
//   const mobile = first?.mobile_no;

//   if (!mobile || String(mobile).trim() === '' || String(mobile) === '0') {
//     alert('या ऑर्डरसाठी मोबाईल नंबर उपलब्ध नाही.');
//     return;
//   }

//   const fmt = (date: any) => {
//     try {
//       return date ? formatDate(date, 'dd-MM-yyyy', 'en-IN') : '';
//     } catch {
//       return date || '';
//     }
//   };

//   const booksList = order.booksData?.length ? order.booksData : order.books;

//   // {{5}} — all books except the last get "-copies", last book stays plain
//   // (last book's copies come from {{6}} + static "प्रती" in the template)
//   const lastIdx = booksList.length - 1;
//   const bookNamesStr = booksList
//     .map((b: any, i: number) => {
//       const name = b.bookname || '';
//       if (i === lastIdx) {
//         return name; // last book: no copies here, template appends "- {{6}} प्रती"
//       }
//       return `${name} -${b.bookcopies || 0}`;
//     })
//     .join(' , ');

//   // {{6}} — copies of the LAST book only (matches static "- {{6}} प्रती" suffix)
//   const lastBookCopies = booksList[lastIdx]?.bookcopies || 0;

//   const templateParams = [
//     first?.custname || '',          // {{1}} नाव
//     first?.district || '',          // {{2}} जिल्हा
//     order.order_no || '',           // {{3}} ऑर्डर क्र
//     fmt(first?.bookingdate),        // {{4}} दिनांक
//     bookNamesStr,                   // {{5}} पुस्तक नावे (सर्व वगळून शेवटचे, -प्रती सह)
//     `${lastBookCopies}`             // {{6}} शेवटच्या पुस्तकाच्या प्रती
//   ];

//   this.sendingWhatsApp[order.order_no] = true;

//   this.service.sendWhatsAppReceipt({
//     mobile: String(mobile),
//     campaignName: 'courier_j4aut',
//     templateParams
//   }).subscribe({
//     next: (res: any) => {
//       this.sendingWhatsApp[order.order_no] = false;
//       this.whatsAppSent[order.order_no] = true;
//     },
//     error: (err) => {
//       this.sendingWhatsApp[order.order_no] = false;
//       console.error('WhatsApp send failed:', err);
//       alert('WhatsApp मेसेज पाठवताना त्रुटी आली.');
//     }
//   });
// }

  trackByOrderNo(index: number, order: any): string {
  return order?.order_no ?? index;
}

// CHANGED: takes order, not index
markDone(order: any): void {
  console.log('markDone called with:', order);   // ADD THIS

  if (!order) {
    console.warn('markDone: order is undefined/null, aborting');
    return;
  }

  const ids = order.books.map((b: any) => Number(b.id));
  console.log('markDone ids:', ids);   // ADD THIS

  this.service.saveRemovedBookIds(ids).subscribe({
    next: (res) => {
      console.log('saveRemovedBookIds success:', res);   // ADD THIS
      this.doneIds.push(...ids);
      this.booksByOrder = this.booksByOrder.filter(
        (o: any) => o.order_no !== order.order_no
      );
    },
    error: (err) => {
      console.error('saveRemovedBookIds error:', err);   // ADD THIS
      alert('Server error. Entry not removed.');
    }
  });
}



// ================= BUILD WHATSAPP PAYLOAD (shared by single + bulk send) =================
private buildWhatsAppPayload(order: any): { mobile: string; campaignName: string; templateParams: string[] } | null {

  const first = order.books?.[0];
  const mobile = first?.mobile_no;

  if (!mobile || String(mobile).trim() === '' || String(mobile) === '0') {
    return null;
  }

  const fmt = (date: any) => {
    try {
      return date ? formatDate(date, 'dd-MM-yyyy', 'en-IN') : '';
    } catch {
      return date || '';
    }
  };

  const booksList = order.booksData?.length ? order.booksData : order.books;

  const lastIdx = booksList.length - 1;
  const bookNamesStr = booksList
    .map((b: any, i: number) => {
      const name = b.bookname || '';
      if (i === lastIdx) {
        return name;
      }
      return `${name} -${b.bookcopies || 0}`;
    })
    .join(' , ');

  const lastBookCopies = booksList[lastIdx]?.bookcopies || 0;

  return {
    mobile: String(mobile),
    campaignName: 'courier_j4aut',
    templateParams: [
      first?.custname || '',
      first?.district || '',
      order.order_no || '',
      fmt(first?.bookingdate),
      bookNamesStr,
      `${lastBookCopies}`
    ]
  };
}

// ================= SEND SINGLE WHATSAPP (now uses shared payload builder) =================
sendWhatsApp(order: any): void {

  if (!order) return;

  const payload = this.buildWhatsAppPayload(order);

  if (!payload) {
    alert('या ऑर्डरसाठी मोबाईल नंबर उपलब्ध नाही.');
    return;
  }

  this.sendingWhatsApp[order.order_no] = true;

  this.service.sendWhatsAppReceipt(payload).subscribe({
    next: (res: any) => {
      this.sendingWhatsApp[order.order_no] = false;
      this.whatsAppSent[order.order_no] = true;
    },
    error: (err) => {
      this.sendingWhatsApp[order.order_no] = false;
      console.error('WhatsApp send failed:', err);
      alert('WhatsApp मेसेज पाठवताना त्रुटी आली.');
    }
  });
}

// ================= SEND ALL WHATSAPP (bulk, one-shot) =================
sendAllWhatsApp(): void {

  if (!this.booksByOrder.length) {
    alert('पाठवण्यासाठी कोणतीही ऑर्डर उपलब्ध नाही.');
    return;
  }

  if (!confirm(`सर्व ${this.booksByOrder.length} ऑर्डरसाठी WhatsApp मेसेज पाठवायचे आहेत का?`)) return;

  const skipped: string[] = [];
  const failed: string[] = [];
  const sent: string[] = [];

  // Build (order, payload) pairs upfront; skip invalid ones immediately
  const jobs = this.booksByOrder
    .map(order => ({ order, payload: this.buildWhatsAppPayload(order) }))
    .filter(job => {
      if (!job.payload) {
        skipped.push(job.order.order_no);
        return false;
      }
      return true;
    });

  if (!jobs.length) {
    alert('कोणत्याही ऑर्डरसाठी वैध मोबाईल नंबर उपलब्ध नाही.');
    return;
  }

  this.sendingAllWhatsApp = true;
  jobs.forEach(job => this.sendingWhatsApp[job.order.order_no] = true);

  from(jobs).pipe(
    concatMap(job =>
      this.service.sendWhatsAppReceipt(job.payload!).pipe(
        delay(400), // small gap between sends to avoid rate-limiting
        catchError(err => {
          console.error(`WhatsApp send failed for order ${job.order.order_no}:`, err);
          failed.push(job.order.order_no);
          return of(null);
        }),
        concatMap(res => {
          this.sendingWhatsApp[job.order.order_no] = false;
          if (res !== null) {
            this.whatsAppSent[job.order.order_no] = true;
            sent.push(job.order.order_no);
          }
          return of(res);
        })
      )
    )
  ).subscribe({
    complete: () => {
      this.sendingAllWhatsApp = false;

      let msg = `✅ पाठवले: ${sent.length}`;
      if (failed.length) msg += `\n❌ अयशस्वी: ${failed.length} (ऑर्डर: ${failed.join(', ')})`;
      if (skipped.length) msg += `\n⚠️ मोबाईल नंबर नाही: ${skipped.length} (ऑर्डर: ${skipped.join(', ')})`;

      alert(msg);
    }
  });
}

}